import { useContext, useEffect } from 'react';
import { Container, Navbar, Nav, NavDropdown, Form } from 'react-bootstrap';
import { Link, Outlet, useNavigate } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthContext';
import './Header.css';
import { useTranslation } from 'react-i18next'

const Header = () => {
  const { user, logout, customers, selectedCustomer, switchCustomer } = useContext(AuthContext);
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  useEffect(() => {
    if (localStorage.getItem('slang')) {
      i18n.changeLanguage(localStorage.getItem('slang'));
      if (localStorage.getItem('slang') === 'zh') {
        document.getElementById('switchBox').checked = true;
      } else {
        document.getElementById('switchBox').checked = false;
      }
    } else {
      i18n.changeLanguage('zh');
      localStorage.setItem('slang', 'zh');
      document.getElementById('switchBox').checked = true;
    }
  }, [i18n]);

  const changeLanguage = (action) => {
    if (action === false) {
      localStorage.setItem('slang', 'en');
      i18n.changeLanguage("en");
    } else {
      localStorage.setItem('slang', 'zh');
      i18n.changeLanguage("zh");
    }
  }

  return (
    <>
      <Navbar bg="white" expand="lg" className="border-bottom">
        <Container>
          <Navbar.Brand as={Link} to="/">
            <img
              src="/logo2.png"
              alt="九龍牛奶"
              height="40"
              className="d-inline-block align-top"
              style={{ height: '100%', width: '100%', maxHeight: '70px', maxWidth: '160px', padding: '0px' }}
            />
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="basic-navbar-nav" style={{ maxHeight: '40px' }} />

          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              <Nav.Link as={Link} to="/orders">{t('orderManagement')}</Nav.Link>
              {user?.role === 0 && (
                <>
                  <Nav.Link as={Link} to="/customers">{t('customerManagement')}</Nav.Link>
                  <Nav.Link as={Link} to="/users">{t('userManagement')}</Nav.Link>
                </>
              )}
            </Nav>

            {customers?.length > 1 && (
              <NavDropdown
                title={selectedCustomer ? `店鋪: ${selectedCustomer.cust_name}` : '選擇店鋪'}
                id="customer-dropdown"
                className="me-3"
              >
                {customers.map(customer => (
                  <NavDropdown.Item
                    key={customer.cust_code}
                    onClick={() => switchCustomer(customer)}
                    active={selectedCustomer?.cust_code === customer.cust_code}
                  >
                    {customer.cust_name}
                  </NavDropdown.Item>
                ))}
              </NavDropdown>
            )}

            <Form.Group>
              <div className='translation'>
                <Form.Label>ENG</Form.Label>
                <Form.Label className="switch">
                  <input type="checkbox" id='switchBox'
                    onChange={(e) => changeLanguage(e.target.checked)}
                  />
                  <span className="slider round"></span>
                </Form.Label>
                <Form.Label>中文</Form.Label>
              </div>
            </Form.Group>


            <NavDropdown
              title={user?.login_id || '用戶'}
              id="user-dropdown"
              align="end"
            >
              {/* <NavDropdown.Item as={Link} to="/profile">{t('personalInfo')}</NavDropdown.Item>
              <NavDropdown.Divider /> */}
              <NavDropdown.Item onClick={handleLogout}>{t('logout')}</NavDropdown.Item>
            </NavDropdown>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      <Container className="py-1">
        <Outlet />
      </Container>
    </>
  );
};

export default Header;